import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space3, space6, space8 } = theme();

  return StyleSheet.create({
    container: {
      justifyContent: "flex-start",
      paddingHorizontal: space6,
      paddingVertical: space8,
    },
    containerDesktop: {
      paddingHorizontal: space3,
    },
  });
};

export { style };
